import { formatMoney } from 'libs/shopify'

function Price({ price = 0, originalPrice = null, className = '', classSalePrice = 'text-xs' }) {
  const customClass = `price ${className}`
  const isSale = originalPrice && originalPrice !== 0 && originalPrice > price

  return (
    <div className={customClass}>
      {isSale && (
        <span className={`mr-1 text-neutral-500 line-through ${classSalePrice}`}>{formatMoney(originalPrice)}</span>
      )}
      {formatMoney(price)}
    </div>
  )
}

export default Price
